import {
  sportsHubImage,
  scienceHubImage,
  artHubImage,
  parentsHubImage,
  lunchTimeHubImage,
  newClassImage,
} from "./infiniteImages_SOS_Scroll";

export const sosScrollItems = [
  {
    bgColor: "#f7b815",
    image: sportsHubImage,
    subtitle: "Sports Hub",
    title: "Prostor za buduće šampione",
    text: (
      <>
        Sports Hub u Savremenoj je novi multifunkcionalni prostor koji će uz najsavremeniju opremu fizičko vaspitanje učiniti stvarno drugačijim.
        <br />
        <br />
        Strunjače, sprave, sportski rekviziti — sve na jednom mestu. Deca razvijaju snagu, brzinu, koordinaciju, ravnotežu i timski duh.
      </>
    ),
  },
  {
    bgColor: "#9d1516",
    image: scienceHubImage,
    subtitle: "Science Hub",
    title: "STEAM Lab za uzbudljive eksperimente",
    text: (
      <>
        Savremeni Science Hub je opremljena laboratorija sa svom potrebnom opremom
        za izvođenje pravih eksperimenata — od hemijskih i bioloških ogleda do
        fizičkih istraživanja. Deca rade u grupama, koriste laboratorijsku opremu,
        izvode eksperimente i dokumentuju rezultate kao pravi istraživači.
        <br />
        <br />
        Svaki čas je praktičan, vođen od strane stručnog nastavnika i osmišljen
        tako da deca razumeju — ne pamte napamet. Jer dete koje je samo otkrilo
        kako nešto funkcioniše, to ne zaboravlja.
      </>
    ),
  },
  {
    bgColor: "#2b446b",
    image: artHubImage,
    subtitle: "Creative Art Hub",
    title: "Studio ideja i stvaralaštva",
    text: (
      <>
        Boje, materijali, ideje bez granica — i prostor koji to sve nosi.
        Creative Art kabinet u Savremenoj nije obična učionica. To je pravi studio
        gde deca crtaju, projektuju, prave, izražavaju. Gde se maštanje pretvara
        u umetnost.
        <br />
        <br />
        Svaki učenik ovde ima pravo na svoju viziju — i alate da je ostvari.
        Kreativnost nije talent. Ona je veština koja se gradi. I mi joj dajemo
        novi prostor.
      </>
    ),
  },
  {
    bgColor: "#427042",
    image: parentsHubImage,
    subtitle: "Parents Hub",
    title: "Mesto koji gradi poverenje",
    text: (
      <>
        Savremena je oduvek bila škola koja komunicira sa roditeljima — ne samo
        kroz dnevnik, već licem u lice. Nova sala za sastanke je prostor gde se
        grade partnerstva između škole i porodice.
        <br />
        <br />
        Gde se razgovara, sluša i zajedno traže rešenja. Jer obrazovanje
        funkcioniše kada su roditelji i škola tim. A tim se gradi razgovorom,
        razumevanjem i poverenjem.
      </>
    ),
  },
  {
    bgColor: "#f7b815",
    image: lunchTimeHubImage,
    subtitle: "Lunch Time Hub",
    title: "Kutak za obrok, odmor i razgovor",
    text: (
      <>
        Lunch Time Hub je pažljivo osmišljena antina za obroke Savremenih učenika. Mesto gde učenici prave pauzu od časova, druže se i uživaju u obroku sa drugarima. Učenici mogu unapred poručiti zdrav i raznovrstan ketering obrok, koji ih čeka spreman u vreme ručka.
        <br />
        <br />
        Sve je organizovano tako da pauza bude prijatna, bez žurbe i u opuštenoj
        atmosferi.
      </>
    ),
  },
  {
    bgColor: "#9d1516",
    image: newClassImage,
    subtitle: "Nova prilika za upis u Savremenu",
    title: (
      <>
        Novo odeljenje <br /> I razreda
      </>
    ),
    text: (
      <>
        Sva mesta za generaciju 2026/27. su bila popunjena već u februaru i formirane su liste čekanja. Medjutim, novi prostor Savremene doneo je mogućnost za otvaranje četvrtog odeljenja I razreda.

        <br />
        <br />
        To je novi start za još jednu generaciju koja zaslužuje više od prosečnog obrazovanja. Broj mesta je ograničen — obezbedite jedno od 20 slobodnih mesta!
      </>
    ),
  },
];